import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {MiscModule} from '../../../core/src/lib/misc/misc.module';
import {CoreModule} from '../../../core/src/lib/core/core.module';
import {MatIconModule} from '@angular/material/icon';
import {CommonModule} from '@angular/common';
import {MatButtonModule} from '@angular/material/button';
import {ListboxModule} from 'primeng/listbox';
import {MatDialogModule} from '@angular/material/dialog';
import {InstallationQuoteComponent} from './installation-quote/installation-quote.component';
import {InputTextModule} from 'primeng/inputtext';
import {FileUploadModule} from 'primeng/fileupload';
import {QuoteFilesComponent} from './installation-quote/quote-files/quote-files.component';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {
  InstallationQuoteBodyComponent
} from './installation-quote/installation-quote-body/installation-quote-body.component';

@NgModule({
  declarations: [
    InstallationQuoteComponent,
    QuoteFilesComponent,
    InstallationQuoteBodyComponent
  ],
  imports: [
    CoreModule,
    MatIconModule,
    BrowserModule,
    CommonModule,
    MatButtonModule,
    ListboxModule,
    MiscModule,
    MatDialogModule,
    InputTextModule,
    FileUploadModule,
    MatProgressBarModule
  ],
  exports: [
    InstallationQuoteComponent,
    QuoteFilesComponent,
    InstallationQuoteBodyComponent
  ]
})
export class QuotesModule {
}
